import { render, staticRenderFns } from "./TeamCenter.vue?vue&type=template&id=4bc5f27d&scoped=true&lang=pug&"
import script from "./TeamCenter.vue?vue&type=script&lang=js&"
export * from "./TeamCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5f27d",
  null
  
)

export default component.exports